module.exports = __webpack_public_path__ + "static/media/multiple-choice-flip.de5cb9ef.svg";